
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10_15185)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_10_15185)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#A4B1DF"}},[_c('path',{attrs:{"d":"M14.445.45a1 1 0 011 1v4.89a.222.222 0 00.223.222h4.888a1 1 0 110 2h-4.889a2.222 2.222 0 01-2.222-2.222V1.45a1 1 0 011-1z"}}),_c('path',{attrs:{"d":"M5.89 2.45a1.444 1.444 0 00-1.445 1.445v17.111a1.444 1.444 0 001.445 1.445h12.222a1.445 1.445 0 001.444-1.445V7.976l-5.525-5.525H5.89zm-2.436-.99A3.444 3.444 0 015.89.45h8.555a1 1 0 01.707.294l6.112 6.11a1 1 0 01.292.708v13.444a3.445 3.445 0 01-3.444 3.445H5.89a3.445 3.445 0 01-3.445-3.445V3.896c0-.914.363-1.79 1.01-2.436z"}}),_c('path',{attrs:{"d":"M6.111 11.229a1 1 0 011-1h9.778a1 1 0 011 1v8.555a1 1 0 01-1 1H7.111a1 1 0 01-1-1V11.23zm2 1v6.555h7.778V12.23H8.111z"}}),_c('path',{attrs:{"d":"M6.111 16.118a1 1 0 011-1h9.778a1 1 0 110 2H7.111a1 1 0 01-1-1z"}}),_c('path',{attrs:{"d":"M10.78 10.229a1 1 0 011 1v8.555a1 1 0 11-2 0V11.23a1 1 0 011-1z"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10_15185"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_10_15185"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .45)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    